/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfGetFormBuilderByIdDto } from '../models/custom-result-of-get-form-builder-by-id-dto';
import { CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto } from '../models/custom-result-of-paginated-list-of-get-form-builder-responses-by-form-builder-id-dto';
import { CustomResultOfPaginatedListOfGetFormBuildersWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-form-builders-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { formBuildersCreate } from '../fn/form-builders/form-builders-create';
import { FormBuildersCreate$Params } from '../fn/form-builders/form-builders-create';
import { formBuildersCreateFormBuilderResponse } from '../fn/form-builders/form-builders-create-form-builder-response';
import { FormBuildersCreateFormBuilderResponse$Params } from '../fn/form-builders/form-builders-create-form-builder-response';
import { formBuildersDelete } from '../fn/form-builders/form-builders-delete';
import { FormBuildersDelete$Params } from '../fn/form-builders/form-builders-delete';
import { formBuildersGetFormBuilderById } from '../fn/form-builders/form-builders-get-form-builder-by-id';
import { FormBuildersGetFormBuilderById$Params } from '../fn/form-builders/form-builders-get-form-builder-by-id';
import { formBuildersGetFormBuilderResponsesByFormBuilderId } from '../fn/form-builders/form-builders-get-form-builder-responses-by-form-builder-id';
import { FormBuildersGetFormBuilderResponsesByFormBuilderId$Params } from '../fn/form-builders/form-builders-get-form-builder-responses-by-form-builder-id';
import { formBuildersGetFormBuildersWithPagination } from '../fn/form-builders/form-builders-get-form-builders-with-pagination';
import { FormBuildersGetFormBuildersWithPagination$Params } from '../fn/form-builders/form-builders-get-form-builders-with-pagination';
import { formBuildersUpdateGet } from '../fn/form-builders/form-builders-update-get';
import { FormBuildersUpdateGet$Params } from '../fn/form-builders/form-builders-update-get';
import { formBuildersUpdatePut } from '../fn/form-builders/form-builders-update-put';
import { FormBuildersUpdatePut$Params } from '../fn/form-builders/form-builders-update-put';
import { formBuildersUploadBackgroundImage } from '../fn/form-builders/form-builders-upload-background-image';
import { FormBuildersUploadBackgroundImage$Params } from '../fn/form-builders/form-builders-upload-background-image';

@Injectable({ providedIn: 'root' })
export class FormBuildersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formBuildersCreate()` */
  static readonly FormBuildersCreatePath = '/FormBuilders/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersCreate$Response(params: FormBuildersCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return formBuildersCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersCreate(params: FormBuildersCreate$Params, context?: HttpContext): Observable<CustomResult> {
    return this.formBuildersCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `formBuildersUpdateGet()` */
  static readonly FormBuildersUpdateGetPath = '/FormBuilders/Update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuildersUpdateGet$Response(params?: FormBuildersUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetFormBuilderByIdDto>> {
    return formBuildersUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuildersUpdateGet(params?: FormBuildersUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetFormBuilderByIdDto> {
    return this.formBuildersUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetFormBuilderByIdDto>): CustomResultOfGetFormBuilderByIdDto => r.body)
    );
  }

  /** Path part for operation `formBuildersUpdatePut()` */
  static readonly FormBuildersUpdatePutPath = '/FormBuilders/Update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersUpdatePut$Response(params: FormBuildersUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return formBuildersUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersUpdatePut(params: FormBuildersUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.formBuildersUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `formBuildersDelete()` */
  static readonly FormBuildersDeletePath = '/FormBuilders/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersDelete$Response(params: FormBuildersDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return formBuildersDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersDelete(params: FormBuildersDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.formBuildersDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `formBuildersGetFormBuildersWithPagination()` */
  static readonly FormBuildersGetFormBuildersWithPaginationPath = '/FormBuilders/GetFormBuildersWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersGetFormBuildersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersGetFormBuildersWithPagination$Response(params: FormBuildersGetFormBuildersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetFormBuildersWithPaginationDto>> {
    return formBuildersGetFormBuildersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersGetFormBuildersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersGetFormBuildersWithPagination(params: FormBuildersGetFormBuildersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetFormBuildersWithPaginationDto> {
    return this.formBuildersGetFormBuildersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetFormBuildersWithPaginationDto>): CustomResultOfPaginatedListOfGetFormBuildersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `formBuildersUploadBackgroundImage()` */
  static readonly FormBuildersUploadBackgroundImagePath = '/FormBuilders/UploadBackgroundImage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersUploadBackgroundImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  formBuildersUploadBackgroundImage$Response(params?: FormBuildersUploadBackgroundImage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return formBuildersUploadBackgroundImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersUploadBackgroundImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  formBuildersUploadBackgroundImage(params?: FormBuildersUploadBackgroundImage$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.formBuildersUploadBackgroundImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `formBuildersGetFormBuilderById()` */
  static readonly FormBuildersGetFormBuilderByIdPath = '/Form';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersGetFormBuilderById()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuildersGetFormBuilderById$Response(params?: FormBuildersGetFormBuilderById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetFormBuilderByIdDto>> {
    return formBuildersGetFormBuilderById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersGetFormBuilderById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuildersGetFormBuilderById(params?: FormBuildersGetFormBuilderById$Params, context?: HttpContext): Observable<CustomResultOfGetFormBuilderByIdDto> {
    return this.formBuildersGetFormBuilderById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetFormBuilderByIdDto>): CustomResultOfGetFormBuilderByIdDto => r.body)
    );
  }

  /** Path part for operation `formBuildersCreateFormBuilderResponse()` */
  static readonly FormBuildersCreateFormBuilderResponsePath = '/Form';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersCreateFormBuilderResponse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersCreateFormBuilderResponse$Response(params: FormBuildersCreateFormBuilderResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return formBuildersCreateFormBuilderResponse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersCreateFormBuilderResponse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersCreateFormBuilderResponse(params: FormBuildersCreateFormBuilderResponse$Params, context?: HttpContext): Observable<CustomResult> {
    return this.formBuildersCreateFormBuilderResponse$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `formBuildersGetFormBuilderResponsesByFormBuilderId()` */
  static readonly FormBuildersGetFormBuilderResponsesByFormBuilderIdPath = '/FormBuilders/GetFormBuilderResponsesByFormBuilderId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuildersGetFormBuilderResponsesByFormBuilderId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersGetFormBuilderResponsesByFormBuilderId$Response(params: FormBuildersGetFormBuilderResponsesByFormBuilderId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto>> {
    return formBuildersGetFormBuilderResponsesByFormBuilderId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuildersGetFormBuilderResponsesByFormBuilderId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuildersGetFormBuilderResponsesByFormBuilderId(params: FormBuildersGetFormBuilderResponsesByFormBuilderId$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto> {
    return this.formBuildersGetFormBuilderResponsesByFormBuilderId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto>): CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto => r.body)
    );
  }

}
